<script>
    import PageLoader from '../components/PageLoader.svelte'
    import Main from '../components/Main.svelte'
    import SectionCards from '../components/Sections/SectionCards.svelte'
    import Factsheet from '../routes/Factsheet.svelte'
    import { fetchData, getURL } from '../utils/functions'
    import { Link, Route } from 'svelte-navigator'
</script>

<svelte:head>
    <title>Factsheets - Global Shipping Watch</title>
</svelte:head>

{#await fetchData('factsheets')}
    <PageLoader />
{:then data}
    <Main>
        <!-- Begin of Works/projects section -->
        <div class="section section-projects fp-auto-height-responsive bg-primary" data-section="projects">

            <section class="content clearfix">

                <div class="content-centered c-columns">
                <div class="c-title">
                    <h2>Factsheets</h2>
                </div>

                <div class="wrapper clip-overflow anim">
                    <!-- Begin of works/services/products -->
                    <div class="gallery-wrapper">
                    <div class="items-tile">
                        <ul class="c-item-list row small-up-1 medium-up-2 large-up-3">
                            {#each data as factsheet}
                                <li class="column">
                                    <Link to={`/factsheet/${factsheet.context_name}`} class='tile-wrapper'>
                                    <div class="item-img landscape">
                                        <div class="img bg-img" data-image-src={getURL(factsheet.country.flag.url)}></div>
                                    </div>
                                    <div class="item-desc">
                                        <h3 class="title text-shadow">{factsheet.country.name}</h3>
                                        <h4 class="text-shadow">{factsheet.type_of_trade}, {factsheet.year}</h4>
                                    </div>
                                    </Link>
                                </li>
                            {/each}
                        </ul>
                    </div>
                    </div>
                    <!-- End of works/services/products -->
                </div>
                </div>
                <!-- end of left elements -->
            </section>
        </div>
        <!-- End of Works/projects section -->  
        
    </Main>

    {#each data as factsheet}
        
    {/each}
{:catch error}
    <p>{error}</p>
{/await}